import { render, staticRenderFns } from "./CancelJobButton.vue?vue&type=template&id=31d9c7f6&scoped=true&"
import script from "./CancelJobButton.vue?vue&type=script&lang=js&"
export * from "./CancelJobButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9c7f6",
  null
  
)

export default component.exports